import styled from 'styled-components/macro';
import NavLink from "./nav_link";
import {useBaseCommunity, useStoreCommunity} from "../store/hooks";
import classNames from "classnames";

const HeaderTop = styled.div``;
const HeaderMiddle = styled.div`
  background-image: url(${props => props.url});
  height: 142px;
  @media only screen and (max-width: 780px) {
    & {
      height: 108px;
    }
  }
`;
const LogoWrapper = styled.div``;
const Logo = styled.div``;
const HeaderBottom = styled.div``;

const placeholderImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mPc/x8AAoMBwP8UKJsAAAAASUVORK5CYII=';

const CommunityHeader = styled(({className, community, refresh}) => {
    const baseCommunity = useBaseCommunity();
    const storeCommunity = useStoreCommunity(community);
    const logoUrl = storeCommunity?.icon ? `https://img.scored.co/community/${storeCommunity.name.toLowerCase()}-icon-192x192.png?v=${community.icon_id}` : placeholderImage;
    const headerUrl = storeCommunity?.header ? storeCommunity.header : '';
    return (
        <div className={classNames(className, `brand-community-header-container`, baseCommunity === "TheDonald" ? `brand-community-header-3p` : '')}>
            <HeaderTop className="brand-community-header-top" />
            <HeaderMiddle className="brand-community-header" url={headerUrl}>
                <LogoWrapper className="brand-mobile-community-logo-outer">
                    <NavLink href={baseCommunity === "TheDonald" ? '/' : `/c/${community}`} activeOnlyWhenExact react_route onRefresh={refresh}>
                        <Logo className="brand-mobile-community-logo">
                            {((baseCommunity === "TheDonald" && storeCommunity?.name) || baseCommunity !== "TheDonald") &&
                                <img src={logoUrl}/>
                            }
                        </Logo>
                    </NavLink>
                </LogoWrapper>
            </HeaderMiddle>
            <HeaderBottom className="brand-community-header-bottom" />
        </div>
)})`
  ${LogoWrapper} {
    display: none;
  }
  
  @media only screen and (max-width: 780px) {
    ${LogoWrapper} {
      display: flex;
      height: 100%;
      align-items: center;
      justify-content: center;
    }
    ${Logo} {
      width: 82px;
      height: 82px;
      min-height: 82px;
      min-width: 82px;
      background-size: contain;
      background-repeat: no-repeat;
    }
    ${Logo} img {
      border-radius: 50%;
      width: 82px;
      height: 82px;
      min-height: 82px;
      min-width: 82px;
    }
  }
`;

export default CommunityHeader;
